import GC from '@grapecity/spread-sheets';
import i18nEnum from '@/i18ns/vi/i18nEnum';
import commonFn from '@/commons/commonFunction.js';

import explanationFormHelper from '@/commons/workbook/explanationFormHelper';
import FilterOperator from '../wildcards/constants/FilterOperator';

class MISAExplanationFormViewHelper {
  /**
   * Gen clause param filter
   * @param {object} arrayCodition mảng đối tường điều kiện lọc
   * @returns key của trường có giá trị tương ứng
   */
  genTextCellByCondition(arrayCondition, typeCondition) {
    if (!arrayCondition || arrayCondition.length < 1) return null;
    let clauseParams = [];
    clauseParams.push({
      Field: arrayCondition[0].field_code,
      Operator: arrayCondition[0].compare_function,
      Value: arrayCondition[0].value,
      Ors: [],
    });
    if (arrayCondition.length == 1) {
      return JSON.stringify(clauseParams);
    }
    //Trường hợp điều kiện OR
    if (typeCondition == 1) {
      clauseParams[0].Ors = [
        {
          Field: arrayCondition[1].field_code,
          Operator: arrayCondition[1].compare_function,
          Value: arrayCondition[1].value,
        },
      ];
    }
    //Trường hợp điều kiện AND
    else {
      clauseParams.push({
        Field: arrayCondition[1].field_code,
        Operator: arrayCondition[1].compare_function,
        Value: arrayCondition[1].value,
        Ors: [],
      });
    }
    return JSON.stringify(clauseParams);
  }

  /**
   * kiểm tra chuỗi có kết thúc bằng kí tự ## không để mở popup system
   * @param {string} textCell
   * @returns
   */
  checkOpenPopupSystem(textCell, arrSub) {
    let result = [];
    if (textCell && textCell.includes('##')) {
      const keyCode = textCell.split('##')[textCell.split('##').length - 1];
      result = arrSub.filter(obj => obj.code.toLowerCase().includes(keyCode.toLowerCase()));
    }
    return result;
  }
  /**
   * Dạng hiển thị của cell chi tiết
   * @param {*} typeCondition
   * @returns
   */
  mapConditionType(typeCondition) {
    switch (typeCondition) {
      case 0:
        return i18nEnum.ExtraFieldType.Model;
      case 1:
        return i18nEnum.ExtraFieldType.Formula;
      case 2:
        return i18nEnum.ExtraFieldType.Condition;
    }
  }

  /**
   * hàm thực hiện lưu dữ liệu động cột
   * @param {*} wb
   * @param {*} printTemplate
   * @param {*} dataDetail
   */

  saveReportCustomConfigColumn(wb, printTemplate, printConfig) {
    let me = this;
    let cellInsert = [];
    let reportCustom = {};
    let reportCustomSources = [];
    let reportCustomExpGenerals = [];
    let reportCustomSourceDetail = [];
    let reportCustomExpGroupGenerals = [];
    let reportCustomExpGroups = [];
    let activeSheet = wb.getActiveSheet();
    activeSheet.setActiveCell(0, 0);
    var tagSheet = activeSheet.tag();
    let ranges = tagSheet?.InfoDataRanges;
    if (!ranges) return;
    for (var key in ranges) {
      if (ranges.hasOwnProperty(key)) {
        let infoRangeDetail = ranges[key].dataCustomWb;
        let rangeSave = tagSheet.infoRanges[key];
        // xử lý dữ liệu cho report_custom
        let dataCsSou = {
          report_custom_source_id: infoRangeDetail.reportCustomSourceDf.reportCustomSourceId,
          report_custom_id: tagSheet.reportCustom.report_custom_id,
          start_row: rangeSave.row,
          is_merge: infoRangeDetail.reportCustomSourceDf.isMerge,
          end_row: rangeSave.row + rangeSave.rowNumber - 1,
          min_col: rangeSave.col,
          max_col: rangeSave.col + rangeSave.colNumber - 1,
          is_multiple_source: infoRangeDetail.reportCustomSourceDf.is_multiple_source,
          filter_condition: infoRangeDetail.reportCustomSourceDf.filter_condition,
        };
        reportCustomSources.push(dataCsSou);

        let dataExpGen = {
          report_custom_exp_general_id: infoRangeDetail.reportCustomExpGeneralDf.reportCustomExpGeneralId,
          report_custom_source_id: infoRangeDetail.reportCustomSourceDf.reportCustomSourceId,
          is_display_detail: infoRangeDetail.reportCustomExpGeneralDf.isDisplayDetail,
          is_row_total: infoRangeDetail.reportCustomExpGeneralDf.isRowTotal,
          view_type: infoRangeDetail.reportCustomExpGeneralDf.viewType,
        };
        reportCustomExpGenerals.push(dataExpGen);

        infoRangeDetail.reportCustomSourceDetailDf.expForm.forEach(item => {
          let dataCsSouDetail = {
            report_custom_source_detail_id: commonFn.generateUUID(),
            report_custom_source_id: infoRangeDetail.reportCustomSourceDf.reportCustomSourceId,
            data_source_type: infoRangeDetail.reportCustomSourceDetailDf.dataSourceType,
            explanation_form_id: item.explanation_form_id,
            data_source_code: item.explanation_form_code,
          };
          reportCustomSourceDetail.push(dataCsSouDetail);
        });

        let dataCsExpGr = {
          report_custom_exp_group_general_id:
            infoRangeDetail.reportCustomExpGroupGeneralDf.reportCustomExpGroupGeneralId,
          report_custom_source_id: infoRangeDetail.reportCustomSourceDf.reportCustomSourceId,
          is_group_advanced: infoRangeDetail.reportCustomExpGroupGeneralDf.isGroupAdvanced,
          advanced_type: infoRangeDetail.reportCustomExpGroupGeneralDf.advancedType,
          expansion_type: infoRangeDetail.reportCustomExpGroupGeneralDf.expansionType,
        };

        reportCustomExpGroupGenerals.push(dataCsExpGr);
        let tagGroupDetail = activeSheet.getTag(rangeSave.row + rangeSave.numberGroup - 1, rangeSave.col);
        let dataGroupDetail = {
          report_custom_exp_group_id: commonFn.generateUUID(),
          report_custom_exp_group_general_id:
            infoRangeDetail.reportCustomExpGroupGeneralDf.reportCustomExpGroupGeneralId,
          number_order_type: tagGroupDetail.numberOrderType,
          sort_type: 1,
          take_parent_order: true,
          //total_group_type: tagCell.totalGroupType,
          is_parent: true,
          parent_id: tagGroupDetail.id,
          start_row: rangeSave.row + rangeSave.numberGroup,
          min_col: rangeSave.col,
          max_col: rangeSave.col,
          end_row: rangeSave.row + rangeSave.rowNumber - 1,
          group_type: 35,
          idCum: tagGroupDetail.idCum,
        };

        for (let row = rangeSave.row; row < rangeSave.row + rangeSave.rowNumber; row++) {
          for (let col = rangeSave.col; col < rangeSave.col + rangeSave.colNumber; col++) {
            let indexRowParent = rangeSave.row + rangeSave.numberGroup - 1;
            if (row <= rangeSave.row + rangeSave.numberGroup - 1) {
              let tagCell = activeSheet.getTag(row, col);
              if (tagCell) {
                let dataDetail = {
                  report_custom_exp_group_id: tagCell.id,
                  report_custom_exp_group_general_id:
                    infoRangeDetail.reportCustomExpGroupGeneralDf.reportCustomExpGroupGeneralId,
                  field_code: tagCell.fieldCode,
                  number_order_type: tagCell.numberOrderType,
                  sort_type: 1,
                  grade: tagCell.grade,
                  take_parent_order: tagCell.takeParentOrder,
                  total_group_type: tagCell.totalGroupType,
                  is_parent: tagCell.isParent,
                  parent_id: tagCell.parentId,
                  start_row: row,
                  min_col: col,
                  max_col: col,
                  end_row: row,
                  group_type: tagCell.groupType,
                  idCum: tagCell.idCum,
                };
                reportCustomExpGroups.push(dataDetail);
              }
              let dataInsert = me.genInfoCellInsertModeColumns(
                col,
                row,
                activeSheet,
                infoRangeDetail.reportCustomSourceDf?.listModelExp,
                indexRowParent,
                rangeSave.numberGroup,
                false,
              );
              if (dataInsert) {
                cellInsert.push(dataInsert);
              }
            } else {
              let dataInsert = me.genInfoCellInsertModeColumns(
                col,
                row,
                activeSheet,
                infoRangeDetail.reportCustomSourceDf?.listModelExp,
                indexRowParent,
                rangeSave.numberGroup,
                true,
                dataGroupDetail,
              );
              if (dataInsert) {
                cellInsert.push(dataInsert);
              }
            }
          }
        }
        // add group chi tiết
        reportCustomExpGroups.push(dataGroupDetail);
      }
    }

    let tagRC = tagSheet?.reportCustom;
    reportCustom = {
      report_custom_id: tagRC?.report_custom_id,
      report_name: tagRC?.report_name,
      report_code: tagRC?.report_code,
      package_type_code: JSON.stringify(tagRC?.package_type_code),
      is_custom: tagRC?.is_custom,
    };
    var templateJson = JSON.stringify(wb.toJSON());
    var printTemplate = JSON.stringify(printTemplate.toJSON());
    return {
      reportCustomEntity: reportCustom,
      reportCustomPrintEntity: printConfig,
      reportCustomSourceEntities: reportCustomSources,
      reportCustomExpGeneralEntities: reportCustomExpGenerals,
      reportCustomSourceDetailEntities: reportCustomSourceDetail,
      reportCustomExpGroupGeneralEntities: reportCustomExpGroupGenerals,
      templateJson: templateJson,
      printTemplate: printTemplate,
      previewTemplate: me.createdImgPreviewReport(wb, reportCustomSources),
      reportCustomExpGroupEntities: reportCustomExpGroups,
      reportCustomExpCellEntities: cellInsert,
      modeSave: tagSheet.modeSave,
    };
  }

  /**
   * Chuyển đổi thành data mang di lưu
   * @param {*} wb
   */
  saveReportCustomConfig(wb, printTemplate, dataDetail, printConfig) {
    let me = this;
    let cellInsert = [];
    let reportCustomExpGroups = [];
    let reportCustom = {};
    let reportCustomSources = [];
    let reportCustomSourceDetail = [];
    let reportCustomExpGenerals = [];
    let reportCustomExpGroupGenerals = [];
    let activeSheet = wb.getActiveSheet();

    var tagSheet = activeSheet.tag();
    if (dataDetail && dataDetail.length > 0) {
      dataDetail.forEach(item => {
        for (let row = item.tagRow.startRow; row <= item.tagRow.endRow; row++) {
          var tag = activeSheet.getTag(row, -1);
          if (!tag) {
            continue;
          }
          // xử lý lại thêm 1 số trường để lưu dữ liệu
          let data = {
            report_custom_exp_group_id: tag.id,
            report_custom_exp_group_general_id: null,
            field_code: tag.fieldCode,
            number_order_type: tag.numberOrderType,
            sort_type: 1,
            grade: tag.isGroup ? tag.grade : null,
            take_parent_order: tag.takeParentOrder,
            total_group_type: tag.totalGroupType,
            is_parent: tag.isParent,
            parent_id: tag.parentId,
            start_row: row,
            end_row: row,
            group_type: tag.groupType,
            filter_value: tag.filterValue,
            idCum: tag.idCum,
          };
          reportCustomExpGroups.push(data);
          for (let col = item.tagRow.startCol; col <= item.tagRow.endCol; col++) {
            if (tag) {
              let dataInsert = me.genDataSaveCellDetail(
                row,
                col,
                activeSheet.getValue(row, col),
                tag,
                activeSheet,
                item.tagRow.dataCustomWb.reportCustomSourceDf.listModelExp,
              );
              if (dataInsert) {
                cellInsert.push(dataInsert);
              }
            }
          }
        }
        var tagDetail = item.tagRow;
        var tagWb = tagDetail.dataCustomWb;
        reportCustomExpGroups.forEach(ele => {
          if (ele.idCum == tagDetail.idCum) {
            ele.report_custom_exp_group_general_id = tagWb.reportCustomExpGroupGeneralDf.reportCustomExpGroupGeneralId;
          }
        });

        // xử lý dữ liệu cho report_custom
        let dataCsSou = {
          report_custom_source_id: tagWb.reportCustomSourceDf.reportCustomSourceId,
          report_custom_id: tagSheet?.reportCustom?.report_custom_id,
          start_row: tagDetail.startRow,
          is_merge: tagWb.reportCustomSourceDf.isMerge,
          end_row: tagDetail.endRow,
          min_col: tagDetail.startCol,
          max_col: tagDetail.endCol,
          filter_condition: me.standardizeConditions(tagWb.reportCustomSourceDf.conditions),
          is_filter: tagWb.reportCustomSourceDf.is_filter,
        };
        reportCustomSources.push(dataCsSou);

        tagWb.reportCustomSourceDetailDf.expForm.forEach(item => {
          let dataCsSouDetail = {
            report_custom_source_detail_id: commonFn.generateUUID(),
            report_custom_source_id: tagWb.reportCustomSourceDf.reportCustomSourceId,
            data_source_type: tagWb.reportCustomSourceDetailDf.dataSourceType,
            explanation_form_id: item.explanation_form_id,
            data_source_code: item.explanation_form_code,
          };
          reportCustomSourceDetail.push(dataCsSouDetail);
        });

        let dataExpGen = {
          report_custom_exp_general_id: tagWb.reportCustomExpGeneralDf.reportCustomExpGeneralId,
          report_custom_source_id: tagWb.reportCustomSourceDf.reportCustomSourceId,
          is_display_detail: tagWb.reportCustomExpGeneralDf.isDisplayDetail,
          is_row_total: tagWb.reportCustomExpGeneralDf.isRowTotal,
          view_type: tagWb.reportCustomExpGeneralDf.viewType,
        };
        reportCustomExpGenerals.push(dataExpGen);

        let dataCsExpGr = {
          report_custom_exp_group_general_id: tagWb.reportCustomExpGroupGeneralDf.reportCustomExpGroupGeneralId,
          report_custom_source_id: tagWb.reportCustomSourceDf.reportCustomSourceId,
          is_group_advanced: tagWb.reportCustomExpGroupGeneralDf.isGroupAdvanced,
          advanced_type: tagWb.reportCustomExpGroupGeneralDf.advancedType,
        };
        reportCustomExpGroupGenerals.push(dataCsExpGr);
      });
    }

    let tagRC = tagSheet?.reportCustom;
    reportCustom = {
      report_custom_id: tagRC?.report_custom_id,
      report_name: tagRC?.report_name,
      report_code: tagRC?.report_code,
      package_type_code: JSON.stringify(tagRC?.package_type_code),
      is_custom: tagRC?.is_custom,
    };
    var templateJson = JSON.stringify(wb.toJSON());
    var printTemplate = JSON.stringify(printTemplate.toJSON());

    return {
      reportCustomEntity: reportCustom,
      reportCustomPrintEntity: printConfig,
      reportCustomSourceEntities: reportCustomSources,
      reportCustomExpGeneralEntities: reportCustomExpGenerals,
      reportCustomSourceDetailEntities: reportCustomSourceDetail,
      reportCustomExpGroupGeneralEntities: reportCustomExpGroupGenerals,
      templateJson: templateJson,
      printTemplate: printTemplate,
      previewTemplate: me.createdImgPreviewReport(wb, reportCustomSources),
      reportCustomExpGroupEntities: reportCustomExpGroups,
      reportCustomExpCellEntities: cellInsert,
      modeSave: tagSheet.modeSave,
    };
  }

  /**
   * Chuẩn hóa lại điều kiện mang đi lưu
   * @param {*} conditions 
   * @returns 
   */
  standardizeConditions(conditions) {
    if (!conditions || conditions.length == 0) return '';

    let newConditions = conditions.map(condition => {
      let value = condition.value;

      if (condition.compare_function == 'IN')
        value = value?.split('|') || [];

      return {
        Field: condition.field_code,
        Operator: condition.compare_function,
        Value: value
      }
    });

    return JSON.stringify(newConditions);
  }

  /**
   * Tạo ra text để hiển thị lên mẫu khi chọn điều kiện
   * @param {*} arrayCondition
   * @param {*} typeCondition
   */
  genTextByFormCondition(arrayCondition, typeCondition) {
    if (!arrayCondition || arrayCondition.length < 1) return null;
    let clauseParams = '';
    if (!arrayCondition[0].field_code || !arrayCondition[0].compare_function) return null;
    arrayCondition[0].value = arrayCondition[0].value ? arrayCondition[0].value : '';
    clauseParams = `(DK:[${arrayCondition[0].field_code}] ${arrayCondition[0].compare_function} ${isNaN(Number(arrayCondition[0].value)) ? '"' + arrayCondition[0].value + '"' : arrayCondition[0].value
      }`;
    if (arrayCondition[0].value == '') {
      clauseParams = `(DK:[${arrayCondition[0].field_code}] ${arrayCondition[0].compare_function} ""`;
    }
    if (arrayCondition.length == 1) {
      return clauseParams + ')';
    }
    if (!arrayCondition[1].field_code || !arrayCondition[1].compare_function) {
      return clauseParams + ')';
    }
    arrayCondition[1].value = arrayCondition[1].value ? arrayCondition[1].value : '';
    let condition = typeCondition == 1 || typeCondition == 'OR' ? 'OR' : 'AND';
    if (arrayCondition[1].value == '') {
      return `${clauseParams} ${condition} [${arrayCondition[1].field_code}] ${arrayCondition[1].compare_function} "")`;
    }
    return `${clauseParams} ${condition} [${arrayCondition[1].field_code}] ${arrayCondition[1].compare_function} ${isNaN(Number(arrayCondition[1].value)) ? '"' + arrayCondition[1].value + '"' : arrayCondition[1].value
      })`;
  }

  /**
   * Biến đổi từ giá trị cell lên trên form thiết lập
   * @param {string} valueCell Giá trị của cell
   * @param {Array} listModel Danh sách trường dữ liệu thuyết minh
   */
  bindingInfoCellInCotrol(valueCell, listModel) {
    let me = this;
    let settingCell = {};
    if (me.getTypeSummaryTypeCell(valueCell) !== -1) {
      settingCell.typeSummary = me.getTypeSummaryTypeCell(valueCell);
      valueCell = valueCell.trim().slice(valueCell.trim().split('(')[0].length + 1, -1);
    }
    let valueCellClear = valueCell;
    let index = valueCell.indexOf('=');
    if (index !== -1) {
      valueCellClear = valueCell.substring(index + 1);
      let indexDK = valueCell.indexOf('(DK');
      let valueShow = valueCellClear;
      if (indexDK !== -1) {
        settingCell.isCondition = true;
        valueShow = valueCellClear.slice(0, valueCellClear.indexOf('(DK:')).trim();
      }
      let modeCell = valueCell.replace(/\s+/g, '').substring(0, 3);
      switch (modeCell) {
        case i18nEnum.SymbolModeCell.Model + '=':
          // Case 1 Kiểm tra có phải thiết lập theo trường dự
          let inforCell = listModel.find(obj => obj.field_code === valueShow.trim().replace('[', '').replace(']', ''));
          if (inforCell) {
            settingCell.ExtraFieldType = i18nEnum.ExtraFieldType.Model;
            settingCell.fieldCode = inforCell.field_code;
            settingCell.fieldName = inforCell.field_name;
          }
          break;
        case i18nEnum.SymbolModeCell.Formula + '=':
          if (this.checkFormula(valueShow, listModel)) {
            settingCell.ExtraFieldType = i18nEnum.ExtraFieldType.Formula;
            settingCell.formula = valueShow;
          }
          break;
        case i18nEnum.SymbolModeCell.StringValue + '=':
          settingCell.ExtraFieldType = i18nEnum.ExtraFieldType.StringValue;
          settingCell.stringValue = valueShow;
      }
      if (settingCell.isCondition) {
        let valueConditionCell = valueCellClear.slice(valueCellClear.indexOf('(DK:') + 4, -1).trim();
        if (this.validateFormatCondition(valueConditionCell)) {
          settingCell.conditions = this.parseStringToControlCondition(valueConditionCell, listModel);
        }
      }
      return settingCell;
    }
    return null;
  }

  /**
   * Sự kiện check công thức
   * tvtam 06/06/2024
   */
  checkFormula(messageCheck, fieldSelectDatas) {
    let check = true;
    try {
      check = this.validateExpression(
        messageCheck,
        fieldSelectDatas?.map(t => t.field_code),
      );
    } catch {
      return false;
    }
    return check;
  }

  /**
   * Valide biểu thức từ string chuyển sang   tính toán
   * @param {string} expression : biểu thức
   * @param {array} arrayParam  : mảng tên các biến trong biểu thức
   */
  validateExpression(expression, arrayParam) {
    //Kiểm tra trường tồn tại trong mảng hay không
    var fieldsInFormula = this.splitFormula(expression);
    let fieldsInvalid = fieldsInFormula.filter(item => !arrayParam.includes(item));
    if (fieldsInvalid?.length > 0) {
      return {
        status: false,
        errorType: i18nEnum.FormulaErrorType.InvalidField,
        errorData: fieldsInvalid,
      };
    }
    return true;
  }

  /**
   * Tách chuỗi thành mảng các trường được đặt trong []
   * TMNghia 20/03/2024
   * @param {} inputString
   * @returns
   */
  splitFormula(inputString) {
    var regex = /\[(.*?)\]/g;
    var matches = [];
    var match;

    while ((match = regex.exec(inputString)) !== null) {
      matches.push(match[1]);
    }
    return matches;
  }

  /**
   * Kiểm tra định dạng của chuỗi đầu vào theo yêu cầu.
   *
   * @param {string} conditions - Chuỗi đầu vào dạng `${param1}[ĐK: ${conditions}]`, trong đó:
   * - `param1`: chứa các ký tự chữ cái, số và các ký tự đặc biệt `[ ]"`.
   * - `conditions`: chứa các điều kiện phức tạp với các phép so sánh `=`, `!=`, `<=`, `>=`, `<`, `>` và các phép logic `AND`, `OR`.
   * Các điều kiện có thể lồng nhau bằng các cặp dấu ngoặc đơn `(` và `)` để thể hiện sự ưu tiên.
   *
   * @returns {boolean} - Trả về `true` nếu định dạng đúng, ngược lại trả về `false`.
   */
  validateFormatCondition(conditions) {
    let me = this;
    const arrayCondition = ['!=', '<=', '>=', '=', '<', '>', '!*', '*', 'NOT NULL', 'NULL', '[]', 'NOT IN', 'IN', 'IS'];
    const arrayValidateRegex = arrayCondition.map(me.escapeRegex);
    // Biểu thức chính quy để kiểm tra mỗi phần điều kiện
    const conditionStringRegex = `[^,]+(${arrayValidateRegex.join('|')})+[^,]`;
    const conditionRegex = new RegExp(conditionStringRegex);

    // Chuyển đổi chuỗi điều kiện thành chữ hoa để không phân biệt chữ hoa và chữ thường
    conditions = conditions.trim().toUpperCase();

    // Kiểm tra từng phần của chuỗi điều kiện
    let parts = [];
    let balance = 0;
    let lastSplit = 0;
    for (let i = 0; i < conditions.length; i++) {
      // Đếm số lượng dấu ngoặc mở và đóng để phân biệt các phần
      if (conditions[i] === '(') balance++;
      if (conditions[i] === ')') balance--;
      // Khi gặp AND hoặc OR và không có dấu ngoặc mở/kết thúc nào ở cùng cấp độ, chia phần điều kiện ra
      if (balance === 0 && (conditions.slice(i, i + 3) === 'AND' || conditions.slice(i, i + 2) === 'OR')) {
        parts.push(conditions.slice(lastSplit, i).trim());
        // Lưu lại vị trí cuối cùng của phần đã chia
        lastSplit = i + (conditions.slice(i, i + 3) === 'AND' ? 3 : 2);
      }
    }
    // Thêm phần cuối cùng vào mảng parts
    parts.push(conditions.slice(lastSplit).trim());
    let regex = new RegExp(`${arrayValidateRegex.join('|')}`);
    // Kiểm tra từng phần điều kiện
    for (let part of parts) {
      // Nếu phần bắt đầu và kết thúc bằng dấu ngoặc đơn, tiến hành kiểm tra đệ quy
      if (part.startsWith('(') && part.endsWith(')')) {
        // if (!validateConditions(part.slice(1, -1))) return false;
      } else {
        // Nếu không, kiểm tra phần đó có phù hợp với mẫu điều kiện không
        if (!conditionRegex.test(part.trim())) {
          return false;
        } else {
          // Kiểm tra các điều kiện để đảm bảo không có khoảng trắng trong param nếu không có dấu ngoặc kép, ngoặc vuông hoặc ngoặc đơn
          const paramParts = part.trim().split(new RegExp(`\s*(${arrayValidateRegex.join('|')})\s*`));
          for (let param of paramParts) {
            param = param.trim();
            // Nếu param không có dấu ngoặc kép, ngoặc vuông hoặc ngoặc đơn và chứa khoảng trắng và không phải là số, trả về false
            if (
              !regex.test(param) &&
              !param.startsWith('"') &&
              !param.endsWith('"') &&
              !param.startsWith('[') &&
              !param.endsWith(']') &&
              !param.startsWith('(') &&
              !param.endsWith(')') &&
              /\s/.test(param) &&
              isNaN(Number(param))
            ) {
              return false;
            }
          }
        }
      }
    }

    // Nếu tất cả các phần đều thỏa mãn, trả về true
    return true;
    // Trả về kết quả cuối cùng sau khi kiểm tra các điều kiện
    //return validateConditions(conditionPart);
  }
  /**
   * Chuyển đỏi sang giá trị của cell để mang đi Insert
   * @param {Number} row  row index
   * @param {Number} col  col Index
   * @param {string} cellValue value cell
   * @param {Object} tagRow  tag row
   * @param {WorkSheet} sheet worksheet
   * @returns
   */
  genDataSaveCellDetail(row, col, cellValue, tagRow, sheet, listModel) {
    let me = this;
    //let tagCell = sheet.getTag(row, col);
    // khởi tạo các thổng tin chung tất cả loại cell đều có
    let cellInsert = {
      report_custom_exp_cell_id: commonFn.generateUUID(), //id
      report_custom_exp_group_id: tagRow.id, //id dòng
      position_cell: explanationFormHelper.mapNumberToLetter(col) + (row + 1), //tên cell (VD: A1)
      position_col_index: col, //index cột
      position_row_index: row, //index dòng
    };
    if (sheet.getFormula(row, col)) {
      cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Formula;
      return cellInsert;
    }
    if (!cellValue || cellValue == '') return null;
    // Cell số thứ tự cố đinh cho nhóm và dòng dữ liệu chi tiết
    if (col == i18nEnum.ReportExcelFieldType.Order + 1 && !tagRow.isSummary && cellValue == "[STT]") {
      cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Order;
      return cellInsert;
    }
    // Trường hợp là dòng chi tiết
    if (tagRow?.isDetail) {
      let index = cellValue.toString().indexOf('=');
      if (index !== -1) {
        let valueCellClear = cellValue.substring(index + 1);
        let checkCondition = true;
        let indexDK = cellValue.indexOf('(DK');
        if (indexDK !== -1) {
          let valueConditionCell = valueCellClear.slice(valueCellClear.indexOf('(DK:') + 4, -1).trim();
          checkCondition = this.validateFormatCondition(valueConditionCell);
          if (checkCondition) {
            cellInsert.is_condition = true;
            cellInsert.data_condition = me.parseStringToObjects(valueConditionCell);
          }
        }
        if (checkCondition) {
          valueCellClear = cellValue.substring(index + 1).split('(DK:')[0];
          let modeCell = cellValue.replace(/\s+/g, '').substring(0, 3);

          switch (modeCell) {
            case i18nEnum.SymbolModeCell.Model + '=':
              // Case 1 Kiểm tra có phải thiết lập theo trường dự
              let inforCell = listModel?.find(
                obj => obj.field_code === valueCellClear.trim().replace('[', '').replace(']', ''),
              );
              if (inforCell) {
                cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Data;
                cellInsert.data_type = i18nEnum.ExtraFieldType.Model;
                cellInsert.field_code = inforCell.field_code;
                return cellInsert;
              }
              break;
            case i18nEnum.SymbolModeCell.Formula + '=':
              if (this.checkFormula(valueCellClear, listModel)) {
                cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Data;
                cellInsert.data_type = i18nEnum.ExtraFieldType.Formula;
                cellInsert.data_formula = valueCellClear;
                return cellInsert;
              }
              break;
            case i18nEnum.SymbolModeCell.StringValue + '=':
              if (this.checkFormula(valueCellClear, listModel)) {
                cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Data;
                cellInsert.data_type = i18nEnum.ExtraFieldType.StringValue;
                cellInsert.data_string = this.genModeStringValueSave(valueCellClear, listModel);
                return cellInsert;
              }
              break;
          }
        }
      }
    }
    //Khác dòng chi tiết(dòng tổng, nhóm)
    else {
      // Cell ngữ cảnh cố đinh của dòng nhóm
      if (col == i18nEnum.ReportExcelFieldType.Name + 1 && tagRow.isGroup) {
        cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Name;
        cellInsert.field_code = tagRow.fieldCode;
        return cellInsert;
      }
      // Phần loại các cell ở dòng nhóm và tổng
      switch (cellValue) {
        case i18nEnum.ReportExcelFieldTypeText.Empty:
          cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Empty;
          return cellInsert;
        case i18nEnum.ReportExcelFieldTypeText.Summary:
          cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Summary;
          return cellInsert;
        case i18nEnum.ReportExcelFieldTypeText.Count:
          cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Count;
          return cellInsert;
        case i18nEnum.ReportExcelFieldTypeText.Average:
          cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Average;
          return cellInsert;
        case i18nEnum.ReportExcelFieldTypeText.Concat:
          cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Concat;
          return cellInsert;
      }
    }
    cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.FreeText;
    cellInsert.data_constant = cellValue;
    return cellInsert;
  }
  /**
   * Hàm chuyển đổi từ text biểu thức điều kiện sang dạng filter Item của backend màn đi lưu
   * @param {string} input (Ví dụ ĐK1 and ĐK2)
   * @returns
   */
  parseStringToObjects(input) {
    let me = this;
    // Tách chuỗi đầu vào bởi 'and' hoặc 'or' không phân biệt hoa thường
    const parts = input.split(/\s+(and|or)\s+/i);
    // Khởi tạo một mảng để lưu trữ các đối tượng kết quả
    const result = [];
    // Biểu thức chính quy để kiểm tra mỗi phần điều kiện
    // Định nghĩa một regex để bắt tham số, toán tử và giá trị
    const regex = /\[(.+?)\]\s*(!=|<=|>=|=|<|>|!\*|\*|NOT NULL|NULL|\[\]|NOT IN|IN|IS)\s*(.+)/;
    //const regex = new RegExp(conditionStringRegex);

    // Duyệt qua từng phần của chuỗi đã tách
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];

      // Bỏ qua các từ khóa 'and' và 'or'
      if (part.toLowerCase() === 'and' || part.toLowerCase() === 'or') {
        continue;
      }

      // Khớp tham số, toán tử và giá trị bằng regex
      const match = part.match(regex);
      if (match) {
        const param = match[1];
        const operator = match[2];
        let value = match[3];
        if (value.startsWith('"') && value.endsWith('"')) {
          value = value.trim().slice(1, -1);
        }
        // Tạo đối tượng và thêm nó vào mảng kết quả
        result.push({ Field: param, Operator: operator, Value: value, Ors: [] });
      }
    }
    let searchTerm = 'and';
    // Nếu là điều kiện and
    if (input.toLowerCase().indexOf(searchTerm) != -1) {
      return JSON.stringify(result);
    }
    // Nếu là OR
    else {
      if (result[1] && result[1] != null) {
        result[0].Ors.push(result[1]);
      }
      return JSON.stringify([result[0]]);
    }
  }
  /**
   * Biếu đổi từ string biểu thức điều kiện thành đối tượng để hiển thị lại form nhập liệu người dùng
   * @param {string} textCondition Biểu thức điều kiện
   * @param {Array} listModel Danh sách trường dữ liệu
   * @returns
   */
  parseStringToControlCondition(textCondition, listModel) {
    let me = this;
    // Bước 1: Tạo hàm phân tích cú pháp để xử lý các điều kiện lồng nhau
    function parseConditions(input) {
      const operators = [...me.generateCaseCombinations('and'), ...me.generateCaseCombinations('or')];
      let result = [];
      let currentOperator = null;

      operators.forEach(operator => {
        if (input.includes(operator)) {
          currentOperator = operator.trim();
          input.split(operator).forEach(subCondition => {
            result.push(parseConditions(subCondition));
          });
          return false; // Thoát khỏi vòng lặp khi tìm thấy operator
        }
      });

      if (currentOperator === null) {
        // Bước 2: Xác định toán tử so sánh
        const comparisonOperators = [
          '!=',
          '<=',
          '>=',
          '=',
          '<',
          '>',
          '!*',
          '*',
          'NOT NULL',
          'NULL',
          '[]',
          'NOT IN',
          'IN',
          'IS',
        ];
        let foundOperator = null;
        let param, value;

        for (let operator of comparisonOperators) {
          if (input.includes(operator)) {
            [param, value] = input.split(operator);
            foundOperator = operator;
            break;
          }
        }

        if (foundOperator === null) {
          throw new Error(`Invalid condition: ${input}`);
        }

        // Bước 3: Xử lý giá trị thành số hoặc chuỗi
        value = value.trim();
        // Kiểm tra nếu giá trị là chuỗi được bao quanh bởi dấu nháy kép
        if (value.startsWith('"') && value.endsWith('"')) {
          value = value.substring(1, value.length - 1); // Loại bỏ dấu nháy kép
        }

        // Kiểm tra nếu giá trị là số, chuyển đổi thành kiểu number
        if (!isNaN(value) && value.trim() != '') {
          value = Number(value);
        }
        let inforMolde = null;
        if (listModel) {
          inforMolde = listModel.find(obj => obj.field_code === param.trim().slice(1, -1));
        }

        return {
          field_code: param.trim().slice(1, -1),
          field_name: inforMolde?.field_name,
          compare_function: foundOperator,
          value: value,
        };
      }

      return { conditions: result, type: currentOperator };
    }

    return parseConditions(textCondition);
  }

  /**
   * Hàm gen các tổ hợp hoa thường
   * @param {string} str
   * @returns
   */
  generateCaseCombinations(str) {
    let result = [];

    function recurse(current, index) {
      if (index === str.length) {
        result.push(current);
        return;
      }

      // Ký tự hiện tại
      let char = str[index];

      // Thêm ký tự chữ thường
      recurse(current + char.toLowerCase(), index + 1);

      // Thêm ký tự chữ hoa
      recurse(current + char.toUpperCase(), index + 1);
    }

    // Bắt đầu đệ quy với chuỗi rỗng và chỉ số 0
    recurse('', 0);

    return result;
  }

  // Hàm để thoát các ký tự đặc biệt trong regex
  //tvtam
  escapeRegex(string) {
    return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }
  /**
   * Hàm chuyển đổi từ text sang mảng json làm đầu vào cho mode ghép chuỗi
   * @param {String} valueCell
   */
  genModeStringValueSave(valueCell, filedModels) {
    // Biểu thức chính quy để tách chuỗi dựa trên dấu ngoặc vuông và các từ khác
    let arrayValueSave = [];
    // Sử dụng match để tìm các phần tử phù hợp
    const result = valueCell.split(/(\[[^\]]+\])/);
    let indexModel = 0;
    result.forEach((element, index) => {
      if (
        element.trim().startsWith('[') &&
        element.trim().startsWith('[') &&
        filedModels?.find(obj => obj.field_code === element.trim().slice(1, -1))
      ) {
        if (result.slice(indexModel, index + 1).join('') && result.slice(indexModel, index + 1).join('') != '') {
          arrayValueSave.push({
            Type: 1,
            Value: result.slice(indexModel, index).join(''),
          });
        }
        arrayValueSave.push({
          Type: 2,
          Value: element.trim().slice(1, -1),
        });
        indexModel = index + 1;
      } else if (index == result.length - 1) {
        if (result.slice(indexModel, index + 1).join('') && result.slice(indexModel, index + 1).join('') != '') {
          arrayValueSave.push({
            Type: 1,
            Value: result.slice(indexModel, index + 1).join(''),
          });
        }
      }
    });
    if (arrayValueSave.length > 0) {
      return JSON.stringify(arrayValueSave);
    }
    return null;
  }
  /**
   * Tạo ảnh xem trước của mẫu in thuyết minh
   * @param {*} wb
   * @param {array} reportCustomSources Mảng đối tượng các vùng dữ liệu
   * @returns
   */
  createdImgPreviewReport(wb, reportCustomSources) {
    let activeSheet = wb.getActiveSheet();
    let colCount = activeSheet.getColumnCount();
    let wbhelper = new GC.Spread.Sheets.Workbook();
    wbhelper.fromJSON(wb.toJSON());
    let acSheet = wbhelper.getActiveSheet();
    // Xóa các cột thừa
    let maxCol = null,
      minCol = null,
      startRow = null,
      endRow = null;
    maxCol = reportCustomSources.reduce((max, obj) => (obj.max_col > max ? obj.max_col : max), -Infinity);
    minCol = reportCustomSources.reduce((min, obj) => (obj.min_col < min ? obj.min_col : min), Infinity);
    startRow = reportCustomSources.reduce((min, obj) => (obj.start_row < min ? obj.start_row : min), Infinity);
    endRow = reportCustomSources.reduce((max, obj) => (obj.end_row > max ? obj.end_row : max), -Infinity);
    if (maxCol != null && minCol != null && startRow != null && endRow != null) {
      let rangeAll = acSheet.getRange(0, 0, acSheet.getRowCount(), acSheet.getColumnCount(), GC.Spread.Sheets.SheetArea.viewport);
      rangeAll.backColor('#ffffff');
      let indexRowDelete = [];
      for (let c = 0; c <= acSheet.getColumnCount(); c++) {
        for (let r = 0; r <= acSheet.getRowCount(); r++) {
          if (acSheet.getFormula(r, c)) {
            indexRowDelete.push(r);
            continue;
          }
        }
      }
      let columnCount = acSheet.getColumnCount();
      for (let i = 0; i < indexRowDelete.length; i++) {
        acSheet.addRows(indexRowDelete[i] + 1, 1);
        for (let c = 0; c <= acSheet.getColumnCount(); c++) {
          if (!acSheet.getFormula(indexRowDelete[i], c)) {
            acSheet.setValue(indexRowDelete[i] + 1, c, acSheet.getValue(indexRowDelete[i], c));
          }
        }
        acSheet.copyTo(indexRowDelete[i], 0, indexRowDelete[i] + 1, 0, 1, columnCount, GC.Spread.Sheets.CopyToOptions.style);
        acSheet.deleteRows(indexRowDelete[i], 1);
      }
      acSheet.deleteColumns(maxCol + 1, colCount - maxCol);
      acSheet.deleteColumns(0, minCol);
      //Xóa dòng thiết lập chỉ để header và chân chữa ký
      acSheet.deleteRows(startRow, endRow - startRow + 1);

      for (let index = 0; index < startRow; index++) {
        acSheet.autoFitRow(index);
      }
      // Auto thêm 5 dòng mặc định
      acSheet.addRows(startRow, 5);
      let style = new GC.Spread.Sheets.Style();
      let border = new GC.Spread.Sheets.LineBorder('black', GC.Spread.Sheets.LineStyle.thin); // Đường viền màu đen, độ dày mỏng
      let range = acSheet.getRange(startRow, 0, 5, maxCol);
      style.borderLeft = border;
      style.borderTop = border;
      style.borderRight = border;
      style.borderBottom = border;
      range.setStyle(style);
    }


    return JSON.stringify(wbhelper.toJSON());
  }
  /**
   * Gen giá trị cell ở mode thiết lập động cột
   * @param {Number} colIndex chỉ số cột
   * @param {Number} rowIndex chỉ số dòng
   * @param {WorkSheet} sheet worksheet
   * @param {array} listModel danh sách trường dữ liệu
   * @param {array} indexRowParent index cột cha
   */
  genInfoCellInsertModeColumns(
    colIndex,
    rowIndex,
    sheet,
    listModel,
    indexRowParent,
    numberGroup,
    isDetail,
    dataGroupDetail,
  ) {
    let tagParentCell = sheet.getTag(indexRowParent, colIndex);
    if (!tagParentCell) {
      for (let index = 1; index < numberGroup; index++) {
        tagParentCell = sheet.getTag(indexRowParent - index, colIndex);
        if (tagParentCell) break;
      }
    }
    let cellValue = sheet.getValue(rowIndex, colIndex);
    if (!tagParentCell || !tagParentCell?.id) return null;
    let cellInsert = {
      report_custom_exp_cell_id: commonFn.generateUUID(), //id
      report_custom_exp_group_id: tagParentCell?.id, //id nhóm cha
      position_cell: explanationFormHelper.mapNumberToLetter(colIndex) + (rowIndex + 1), //tên cell (VD: A1)
      position_col_index: colIndex, //index cột
      position_row_index: rowIndex, //index dòng
    };
    if (sheet.getFormula(rowIndex, colIndex)) {
      cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Formula;
      return cellInsert;
    }
    if (!cellValue || cellValue == '') return null;

    // Trường hợp là dòng chi tiết
    if (isDetail) {
      // Cell ngữ cảnh cố đinh của dòng chi tiết
      cellInsert.report_custom_exp_group_id = this.genIdParentCell(colIndex, rowIndex, sheet);

      switch (cellValue) {
        case i18nEnum.ReportExcelFieldTypeText.Empty:
          cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Empty;
          return cellInsert;
        case i18nEnum.ReportExcelFieldTypeText.Summary:
          cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Summary;
          return cellInsert;
        case i18nEnum.ReportExcelFieldTypeText.Count:
          cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Count;
          return cellInsert;
        case i18nEnum.ReportExcelFieldTypeText.Average:
          cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Average;
          return cellInsert;
        case i18nEnum.ReportExcelFieldTypeText.Concat:
          cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Concat;
          return cellInsert;
      }
      // trường hợp là cell dữ liệu chi tiết
      if (this.getTypeSummaryTypeCell(cellValue) !== -1) {
        cellInsert.report_custom_exp_group_id = dataGroupDetail.report_custom_exp_group_id;
        cellInsert.summary_type = this.getTypeSummaryTypeCell(cellValue);
        cellValue = cellValue.slice(cellValue.split('(')[0].length + 1, -1).trim();
        let index = cellValue.toString().indexOf('=');
        if (index !== -1) {
          let valueCellClear = cellValue.substring(index + 1);
          let checkCondition = true;
          let indexDK = cellValue.indexOf('(DK');
          if (indexDK !== -1) {
            let valueConditionCell = valueCellClear.slice(valueCellClear.indexOf('(DK:') + 4, -1).trim();
            checkCondition = this.validateFormatCondition(valueConditionCell);
            if (checkCondition) {
              cellInsert.is_condition = true;
              cellInsert.data_condition = this.parseStringToObjects(valueConditionCell);
            }
          }
          if (checkCondition) {
            valueCellClear = cellValue.substring(index + 1).split('(DK:')[0];
            let modeCell = cellValue.replace(/\s+/g, '').substring(0, 3);

            switch (modeCell) {
              case i18nEnum.SymbolModeCell.Model + '=':
                // Case 1 Kiểm tra có phải thiết lập theo trường dự
                let inforCell = listModel.find(
                  obj => obj.field_code === valueCellClear.trim().replace('[', '').replace(']', ''),
                );
                if (inforCell) {
                  cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Data;
                  cellInsert.data_type = i18nEnum.ExtraFieldType.Model;
                  cellInsert.field_code = inforCell.field_code;
                  return cellInsert;
                }
                break;
              case i18nEnum.SymbolModeCell.Formula + '=':
                if (this.checkFormula(valueCellClear, listModel)) {
                  cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Data;
                  cellInsert.data_type = i18nEnum.ExtraFieldType.Formula;
                  return cellInsert;
                }
            }
          }
        }
      }
    }
    //Khác dòng chi tiết(dòng tổng, nhóm)
    else {
      let tagCell = sheet.getTag(rowIndex, colIndex);
      if (tagCell && tagCell.isGroup && !tagCell.isSummary) {
        // Cell ngữ cảnh cố đinh của dòng nhóm
        cellInsert.report_custom_exp_group_id = tagCell.id;
        cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.Name;
        cellInsert.field_code = tagCell.fieldCode;
        return cellInsert;
      } else if (tagCell?.isSummary) return null;
      cellInsert.report_field_type = i18nEnum.ReportExcelFieldType.FreeText;
      cellInsert.data_constant = cellValue;
      return cellInsert;
    }
  }

  /**
   * check type của cell
   * @param {string} valueCell Giá trị của cell
   */
  getTypeSummaryTypeCell(valueCell) {
    if (!valueCell) return -1;
    let summaryTextType = valueCell.split('(')[0].trim();
    switch (summaryTextType) {
      case i18nEnum.SummaryText.Summary:
        return i18nEnum.SummaryTypeCell.Summary;
      case i18nEnum.SummaryText.Count:
        return i18nEnum.SummaryTypeCell.Count;
      case i18nEnum.SummaryText.Average:
        return i18nEnum.SummaryTypeCell.Average;
      default:
        return -1;
    }
  }
  /**
   * Lấy id của dòng cha của cell
   * @param {Number} indexCol chỉ số cột
   * @param {Number} indexRow chỉ số dòng
   * @param {WorkSheet} sheet worksheet
   * @returns Guid ID dòng cha
   */
  genIdParentCell(indexCol, indexRow, sheet) {
    while (indexRow > 0) {
      let tagCell = sheet.getTag(indexRow, indexCol);
      if (tagCell && tagCell.isColSum) {
        return tagCell.id;
      }
      indexRow--;
    }
  }

  addRowsDetailDefaultGenCol(sheet, indexCol, indexRow, numberGroup, idCum) {
    let infoRange = {
      idCum: idCum,
      row: indexRow,
      col: indexCol,
      rowNumber: numberGroup + 1,
      colNumber: numberGroup + 1,
      numberGroup: numberGroup,
    };
    let tagSheet = sheet.tag();
    if (!tagSheet) {
      tagSheet = {};
    }
    if (!tagSheet.infoRanges) {
      tagSheet.infoRanges = {};
    }
    tagSheet.infoRanges[idCum.toString()] = infoRange;
    sheet.tag(tagSheet);
    var range = sheet.getRange(infoRange.row + numberGroup, infoRange.col, 1, infoRange.colNumber);
    range.tag(infoRange.idCum.toString());
    let style = new GC.Spread.Sheets.Style();
    let border = new GC.Spread.Sheets.LineBorder('black', GC.Spread.Sheets.LineStyle.thin); // Đường viền màu đen, độ dày mỏng
    style.borderLeft = border;
    style.borderTop = border;
    style.borderRight = border;
    style.borderBottom = border;
    style.backColor = '#FFCCCC';
    range.setStyle(style);
  }

  /**
   *
   * @param {number} cellRow chỉ số dòng của cell
   * @param {number} cellColumn chỉ số cột của cell
   * @param {number} startRow chỉ số dòng bắt đầu của range
   * @param {number} startColumn chỉ số cột bắt đầu của range
   * @param {number} rowCount số lượng dòng của range
   * @param {number} columnCount số lượng cột của range
   * @returns  {boolean} - Trả về true nếu cell thuộc range, ngược lại trả về false
   */
  isCellInRange(cellRow, cellColumn, startRow, startColumn, rowCount, columnCount) {
    // Kiểm tra xem cell có thuộc range không
    var isInRange =
      cellRow >= startRow &&
      cellRow < startRow + rowCount &&
      cellColumn >= startColumn &&
      cellColumn < startColumn + columnCount;

    return isInRange;
  }

  /**
   * Update Range khi thêm xóa dòng cột
   * @param {*} args event của sheet (thêm xóa dòng cột)
   * @param {*} range  thong tin vùng cần update
   */
  updateInfoRange(args, range) {
    if (!range) return;
    let countRowColChange = args.newValue;

    if (args.isUndo) {
      countRowColChange = args.oldValue;
    }
    switch (args.propertyName) {
      case 'deleteRows':
        if (
          (args.row < range.row && args.row + countRowColChange >= range.row) ||
          (args.row >= range.row && args.row <= range.row + range.numberGroup - 1)
        ) {
          this.updateRangeInsert(range.idCum, args.sheet, args.isUndo);
          break;
        } else if (args.row < range.row) {
          range.row -= args.isUndo ? -countRowColChange : countRowColChange;
          break;
        } else if (args.row > range.row + range.numberGroup - 1 && args.row <= range.row + range.rowNumber - 1) {
          range.rowNumber -= args.isUndo ? -countRowColChange : countRowColChange;
          break;
        }
        break;
      case 'addRows':
        if (args.row > range.row && args.row <= range.row + range.rowNumber - 1) {
          this.updateRangeInsert(range.idCum, args.sheet, args.isUndo);
        } else if (args.row <= range.row) {
          range.row += args.isUndo ? -countRowColChange : countRowColChange;
        }
        break;
      case 'deleteColumns':
        if (
          (range.col <= args.col && args.col <= range.col + range.colNumber - 1) ||
          (args.col < range.col && args.col + countRowColChange >= range.col)
        ) {
          this.updateRangeInsert(range.idCum, args.sheet, args.isUndo);
        } else if (args.col < range.col) {
          range.col -= args.isUndo ? -countRowColChange : countRowColChange;
        }
        break;
      case 'addColumns':
        if (range.col <= args.col && args.col < range.col + range.colNumber - 1) {
          this.updateRangeInsert(range.idCum, args.sheet, args.isUndo);
        } else if (args.col < range.col) {
          range.col += args.isUndo ? -countRowColChange : countRowColChange;
        }
        break;
    }
  }
  /**
   * Xóa range khi xóa nhóm
   * @param {Number} idCum id của range
   * @param {WorkSheet} sheet
   */
  updateRangeInsert(idCum, sheet) {
    let tagSheet = sheet.tag();
    if (!tagSheet) {
      return;
    }
    if (!tagSheet.infoRanges) {
      return;
    }
    delete tagSheet.infoRanges[idCum.toString()];
    delete tagSheet.InfoDataRanges[idCum.toString()];
    sheet.tag(tagSheet);
  }

  // Hàm chuyển đổi chỉ số cột thành ký hiệu cột (A, B, C, ...)
  getColumnLetter(colIndex) {
    let columnLetter = '';
    while (colIndex >= 0) {
      columnLetter = String.fromCharCode((colIndex % 26) + 65) + columnLetter;
      colIndex = Math.floor(colIndex / 26) - 1;
    }
    return columnLetter;
  }
  // hàm lấy index để thực hiện chuyển đổi
  getCellReference(rowIndexRef, colIndex) {
    const columnLetter = this.getColumnLetter(colIndex);
    return columnLetter + (rowIndexRef + 1);
  }

  /**
   * Tạo mới mẫu in theo giao diện nhập liệu
   * @param {*} wb 
   * @param {*} expForm 
   * @param {*} models 
   * @returns 
   */
  createReportByExplanationTable(wb, expForm, models, printConfig) {
    if (!wb || !models || models.length == 0) return;

    wb.suspendPaint();
    wb.suspendEvent();

    let sheet = wb.getActiveSheet(),
      rowIndex = 4;

    sheet.name(`${expForm.explanation_form_code}.01`)
    sheet.addRows(rowIndex + 1, 1); // Thêm một dòng mới là dòng group
    // khi thêm dòng chi tiết thì thêm luôn 1 dòng tổng
    sheet.addRows(rowIndex, 1);

    //Thiết lập dữ liệu lưu trong tag
    this.setConfigIntoTag(sheet, expForm, models, rowIndex);

    //Thiết lập định dạng
    this.setDefaultStyle(sheet, expForm, rowIndex, models.length + 1);

    //Thiết lập ô dữ liệu
    this.setDataIntoCell(sheet, rowIndex, models);

    //Thiết lập lại định dạng sau khi bind xong dữ liệu
    this.setStyleAfterBinding(sheet, rowIndex);

    //Thiết lập cấu hình in
    this.setPrintConfig(sheet, printConfig, rowIndex, models.length + 1);

    wb.resumeEvent();
    wb.resumePaint();
  }

  /**
   * Gán dữ liệu cấu hình vào tag
   * @param {*} sheet 
   * @param {*} expForm 
   * @param {*} models 
   * @param {*} rowIndex 
   */
  setConfigIntoTag(sheet, expForm, models, rowIndex) {
    let idCum = 1,
      reportCustomExpGeneralId = commonFn.generateUUID(),
      reportCustomExpGroupGeneralId = commonFn.generateUUID(),
      reportCustomSourceId = commonFn.generateUUID();

    var idSummary = commonFn.generateUUID(); // id của dòng tổng
    var tagSummary = {
      isSummary: true,
      id: idSummary,
      idCum: idCum,
      groupType: 20,
      dataCustomWb: {},
      startRow: rowIndex,
      endRow: rowIndex + 1,
      startCol: 1,
      endCol: models.length + 1,
    };

    var idDetail = commonFn.generateUUID(); // id của dòng chi tiết
    var idGroup = commonFn.generateUUID(); // id của dòng group gần dòng chi tiết
    var rowTagDetail = {
      isDetail: true,
      id: idDetail,
      parentId: idGroup,
      idCum: idCum,
      numberOrderType: 1,
      takeParentOrder: true,
      groupType: 5,
      dataCustomWb: {
        groupDataFieldDf: [],
        groupMasterDataSettingDf: [],
        reportCustomExpGeneralDf: {
          isDisplayDetail: true,
          isRowTotal: true,
          reportCustomExpGeneralId: reportCustomExpGeneralId,
          viewType: 0
        },
        reportCustomExpGroupGeneralDf: {
          advancedType: 0,
          isGroupAdvanced: false,
          reportCustomExpGroupGeneralId: reportCustomExpGroupGeneralId,
        },
        reportCustomSourceDf: {
          isMerge: true,
          listModelExp: models,
          reportCustomSourceId: reportCustomSourceId,
        },
        reportCustomSourceDetailDf: {
          dataSourceType: 5,
          expForm: [expForm],
          expFormName: expForm?.explanation_form_code
        }
      },
      startRow: rowIndex,
      endRow: rowIndex + 1,
      startCol: 1,
      endCol: models.length + 1,
    };

    // nếu là dòng chi tiết thì đánh dấu là isDetail
    sheet.setTag(rowIndex + 1, -1, rowTagDetail);
    // set tag cho dòng tổng
    sheet.setTag(rowIndex, -1, tagSummary);

    let cellTag = {};
    cellTag.accompanyingInfo = {
      report_field_type: i18nEnum.ReportExcelFieldType.Order,
    };
    sheet.getCell(rowIndex + 1, 1).tag(cellTag);

  }

  /**
   * Gán dữ liệu cho các ô
   * @param {*} sheet 
   * @param {*} rowIndex 
   * @param {*} models 
   * @returns 
   */
  setDataIntoCell(sheet, rowIndex, models) {
    if (!sheet || !models || models.length == 0) return;

    let startCol = 1;
    for (let i = 0; i < models.length; i++) {
      let model = models[i];
      startCol += 1;

      this.setFormatToCell(model, sheet, rowIndex, startCol);
    }
  }

  /**
   * Thiết lập định dạng theo kiểu dữ liệu
   */
  setFormatToCell(model, sheet, rowIndex, colIndex) {
    if (!model || !sheet) return;

    //Lấy ra các ô cần thao tác
    let cellType = new GC.Spread.Sheets.CellTypes.ComboBox(),
      contentCell = sheet.getCell(rowIndex + 1, colIndex),
      summaryCell = sheet.getCell(rowIndex, colIndex),
      headerCell = sheet.getCell(rowIndex - 1, colIndex),
      dataRange = sheet.getRange(rowIndex, colIndex, 2, 1);

    //CellType Combobox cho dòng tổng
    cellType.items([
      { text: i18nEnum.ReportExcelFieldTypeText.Empty, value: i18nEnum.ReportExcelFieldTypeText.Empty },
      { text: i18nEnum.ReportExcelFieldTypeText.Summary, value: i18nEnum.ReportExcelFieldTypeText.Summary },
      { text: i18nEnum.ReportExcelFieldTypeText.Count, value: i18nEnum.ReportExcelFieldTypeText.Count },
      { text: i18nEnum.ReportExcelFieldTypeText.Average, value: i18nEnum.ReportExcelFieldTypeText.Average },
      { text: i18nEnum.ReportExcelFieldTypeText.Concat, value: i18nEnum.ReportExcelFieldTypeText.Concat },
    ]);
    cellType.editorValueType(GC.Spread.Sheets.CellTypes.EditorValueType.value);

    summaryCell.cellType(cellType);

    contentCell.value(`DL=[${model.field_code}]`);
    headerCell.value(model.field_name);

    switch (model.data_type) {
      case i18nEnum.ModelDataType.Text:
      case i18nEnum.ModelDataType.List:
      case i18nEnum.ModelDataType.Boolean:
        summaryCell.text(i18nEnum.ReportExcelFieldTypeText.Empty);
        dataRange.formatter(i18nEnum.FormatCell.Text);
        sheet.setColumnWidth(colIndex, 200);
        break;

      case i18nEnum.ModelDataType.Number:
      case i18nEnum.ModelDataType.Currency:
      case i18nEnum.ModelDataType.Constant:
        summaryCell.text(i18nEnum.ReportExcelFieldTypeText.Summary);
        dataRange.hAlign(GC.Spread.Sheets.HorizontalAlign.right);
        dataRange.formatter(i18nEnum.FormatCell.Number);
        dataRange.fontFamily(i18nEnum.FontFamily.ArialNarrow);
        dataRange.fontSize('9pt');
        sheet.setColumnWidth(colIndex, 120);
        break;
      case i18nEnum.ModelDataType.Ratio:
        summaryCell.text(i18nEnum.ReportExcelFieldTypeText.Average);
        dataRange.hAlign(GC.Spread.Sheets.HorizontalAlign.right);
        dataRange.formatter(i18nEnum.FormatCell.Constant);
        dataRange.fontFamily(i18nEnum.FontFamily.ArialNarrow);
        dataRange.fontSize('9pt');
        sheet.setColumnWidth(colIndex, 80);
        break;

      case i18nEnum.ModelDataType.Date:
        summaryCell.text(i18nEnum.ReportExcelFieldTypeText.Empty);
        dataRange.formatter(i18nEnum.FormatCell.Short_Date);
        sheet.setColumnWidth(colIndex, 80);
        break;

      default: break;
    }
  }

  /**
   * Thiết lập định dạng cho mẫu in
   */
  setDefaultStyle(sheet, expForm, rowIndex, tableColumnCount) {
    var colCount = sheet.getColumnCount();
    var style = new GC.Spread.Sheets.Style();
    var styleSummary = new GC.Spread.Sheets.Style();
    var border = new GC.Spread.Sheets.LineBorder('black', GC.Spread.Sheets.LineStyle.thin); // Đường viền màu đen, độ dày mỏng
    var range = sheet.getRange(rowIndex + 1, 0, 1, colCount);
    var rangeSummary = sheet.getRange(rowIndex, 0, 1, colCount);

    style.backColor = '#C6E0B4';
    style.borderLeft = border;
    style.borderTop = border;
    style.borderRight = border;
    style.borderBottom = border;
    styleSummary.backColor = 'yellow';
    styleSummary.borderLeft = border;
    styleSummary.borderTop = border;
    styleSummary.borderRight = border;
    styleSummary.borderBottom = border;
    range.setStyle(style);
    sheet.setText(rowIndex + 1, 1, '[STT]');
    sheet.setText(rowIndex - 1, 1, 'STT');
    rangeSummary.setStyle(styleSummary);

    //Toàn bộ sheet
    let wholeSheetRange = sheet.getRange(0, 1, 6, tableColumnCount);
    wholeSheetRange.vAlign(GC.Spread.Sheets.VerticalAlign.center);
    wholeSheetRange.wordWrap(true);
    wholeSheetRange.fontFamily(i18nEnum.FontFamily.TimesNewRoman);

    //Tiêu đề
    let titleRange = sheet.getRange(1, 1, 1, tableColumnCount);
    sheet.addSpan(1, 1, 1, tableColumnCount);
    sheet.setText(1, 1, expForm.explanation_form_name?.toUpperCase() || 'MẪU IN THUYẾT MINH');
    titleRange.fontSize('12pt');
    titleRange.fontWeight('bold');
    titleRange.hAlign(GC.Spread.Sheets.HorizontalAlign.center);

    //Header bảng
    let headerRange = sheet.getRange(rowIndex - 1, 1, 1, tableColumnCount);
    headerRange.setBorder(border, { all: true });
    headerRange.fontWeight('bold');
    headerRange.hAlign(GC.Spread.Sheets.HorizontalAlign.center);

    //Dòng tổng
    let summaryRange = sheet.getRange(rowIndex, 1, 1, tableColumnCount);
    summaryRange.fontWeight('bold');

    //Ô số thứ tự
    let orderRange = sheet.getRange(rowIndex - 1, 1, 3, 1);
    orderRange.hAlign(GC.Spread.Sheets.HorizontalAlign.center);
    sheet.setColumnWidth(orderRange.col, 50);
  }

  /**
   * Thiết lập lại định dạng sau khi bind dữ liệu
   */
  setStyleAfterBinding(sheet, rowIndex) {
    //AutofitRow
    sheet.autoFitRow(rowIndex - 1);
    sheet.autoFitRow(rowIndex);
    sheet.autoFitRow(rowIndex + 1);
    sheet.autoFitRow(rowIndex - 3);

    //Style lại ô tổng
    let summaryCell = sheet.getCell(rowIndex, 2);
    summaryCell.value('Tổng cộng');
    summaryCell.formatter(rowIndex, 2, i18nEnum.FormatCell.General);
    summaryCell.hAlign(GC.Spread.Sheets.HorizontalAlign.left);
    summaryCell.cellType(new GC.Spread.Sheets.CellTypes.Text());
  }

  /**
   * Thiết lập cấu hình in
   * @param {*} sheet 
   * @param {*} rowIndex 
   */
  setPrintConfig(sheet, printConfig, rowIndex, tableColumnCount) {
    if (!sheet) return;

    printConfig.value.report_custom_print_id = commonFn.generateUUID();

    printConfig.value.area_start_row = 0;
    printConfig.value.area_end_row = 5;
    printConfig.value.area_min_col = 1;
    printConfig.value.area_max_col = tableColumnCount;

    printConfig.value.header_start_row = rowIndex - 1;
    printConfig.value.header_end_row = rowIndex - 1;
    printConfig.value.header_min_col = 1;
    printConfig.value.header_max_col = tableColumnCount;

    printConfig.value.is_repeat_header = true;
    printConfig.value.paper_size = i18nEnum.PaperSizeType.PaperA4;
    printConfig.value.orientation = 1;

  }

  /**
  * Tạo ảnh xem trước của báo cáo
  * @param {*} wb
  * @param {array} rangeSetup vùng thiết lập
  * @returns
  */
  createdImgPreviewReportTool(wb, rangeSetup) {
    let activeSheet = wb.getActiveSheet();
    let colCount = activeSheet.getColumnCount();
    let wbhelper = new GC.Spread.Sheets.Workbook();
    wbhelper.fromJSON(wb.toJSON());
    let acSheet = wbhelper.getActiveSheet();
    // Xóa các cột thừa
    let maxCol = rangeSetup?.maxCol,
      minCol = rangeSetup?.minCol,
      startRow = rangeSetup?.startRow,
      endRow = rangeSetup?.endRow;
    if (maxCol != null && minCol != null && startRow != null && endRow != null) {
      let rangeAll = acSheet.getRange(0, 0, acSheet.getRowCount(), acSheet.getColumnCount(), GC.Spread.Sheets.SheetArea.viewport);
      rangeAll.backColor('#ffffff');
      let indexRowDelete = [];
      for (let c = 0; c <= acSheet.getColumnCount(); c++) {
        for (let r = 0; r <= acSheet.getRowCount(); r++) {
          if (acSheet.getFormula(r, c)) {
            indexRowDelete.push(r);
            continue;
          }
        }
      }
      let columnCount = acSheet.getColumnCount();
      for (let i = 0; i < indexRowDelete.length; i++) {
        acSheet.addRows(indexRowDelete[i] + 1, 1);
        for (let c = 0; c <= acSheet.getColumnCount(); c++) {
          if (!acSheet.getFormula(indexRowDelete[i], c)) {
            acSheet.setValue(indexRowDelete[i] + 1, c, acSheet.getValue(indexRowDelete[i], c));
          }
        }
        acSheet.copyTo(indexRowDelete[i], 0, indexRowDelete[i] + 1, 0, 1, columnCount, GC.Spread.Sheets.CopyToOptions.style);
        acSheet.deleteRows(indexRowDelete[i], 1);
      }
      acSheet.deleteColumns(maxCol + 1, colCount - maxCol);
      acSheet.deleteColumns(0, minCol);
      //Xóa dòng thiết lập chỉ để header và chân chữa ký
      acSheet.deleteRows(startRow, endRow - startRow + 1);

      for (let index = 0; index < startRow; index++) {
        acSheet.autoFitRow(index);
      }
      // Auto thêm 5 dòng mặc định
      acSheet.addRows(startRow, 5);
      let style = new GC.Spread.Sheets.Style();
      let border = new GC.Spread.Sheets.LineBorder('black', GC.Spread.Sheets.LineStyle.thin); // Đường viền màu đen, độ dày mỏng
      let range = acSheet.getRange(startRow, 0, 5, maxCol);
      style.borderLeft = border;
      style.borderTop = border;
      style.borderRight = border;
      style.borderBottom = border;
      range.setStyle(style);
    }
    return JSON.stringify(wbhelper.toJSON());
  }
}

export default new MISAExplanationFormViewHelper();
